export interface SchoolMasterItem {
  id: number;
  school_name: string;
  school_code: string;
  udise_code: string;
  block: string;
  school_type: string;
}

export const DAILY_ATTENDANCE_SCHOOLS_MASTER: SchoolMasterItem[] = [
  {
    "id": 1,
    "school_name": "Government Middle School Kaliabas",
    "school_code": "6551",
    "udise_code": "6200206003",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 2,
    "school_name": "Government Middle School Maholi",
    "school_code": "935",
    "udise_code": "6200201801",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 3,
    "school_name": "CM EEE Government Senior Secondary School Biwan",
    "school_code": "819",
    "udise_code": "6200203101",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 4,
    "school_name": "Government Middle School Gokalpur",
    "school_code": "928",
    "udise_code": "6200207702",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 5,
    "school_name": "Government Middle School Ibrahim Bas",
    "school_code": "6014",
    "udise_code": "6200200502",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 6,
    "school_name": "Government Girls Senior Secondary School Ferozpur Jhirka",
    "school_code": "875",
    "udise_code": "6200203201",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 7,
    "school_name": "Government Middle School Kolgaon",
    "school_code": "932",
    "udise_code": "6200200802",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 8,
    "school_name": "Government Middle School Ghatashamsa Bad",
    "school_code": "6101",
    "udise_code": "6200205602",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 9,
    "school_name": "Government Middle School Alipur",
    "school_code": "6092",
    "udise_code": "6200204702",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 10,
    "school_name": "Government Middle School Kherla Kalan Nuh",
    "school_code": "30078",
    "udise_code": "6204100364",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 11,
    "school_name": "Government Middle School Pathrali",
    "school_code": "6011",
    "udise_code": "6200200402",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 12,
    "school_name": "Government Girls Middle School Dorakhi",
    "school_code": "6564",
    "udise_code": "6200207602",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 13,
    "school_name": "Government Middle School Dhamala",
    "school_code": "6012",
    "udise_code": "6200204902",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 14,
    "school_name": "Government Middle School Bawantheri",
    "school_code": "30072",
    "udise_code": "6204100374",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 15,
    "school_name": "Government Middle School Mohammad Bas",
    "school_code": "6096",
    "udise_code": "6200205802",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 16,
    "school_name": "Government Middle School Tigaon",
    "school_code": "941",
    "udise_code": "6200204502",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 17,
    "school_name": "Government Middle School Hamja Pur",
    "school_code": "7165",
    "udise_code": "6200201202",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 18,
    "school_name": "Government Middle School Sidhrawat",
    "school_code": "6020",
    "udise_code": "6200202602",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 19,
    "school_name": "Government Middle School Dungeja",
    "school_code": "6089",
    "udise_code": "6200201502",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 20,
    "school_name": "Government Middle School Saimirbas Nuh Mewat",
    "school_code": "30084",
    "udise_code": "6204100377",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 21,
    "school_name": "Government Middle School Chainpuri Nuh Mewat",
    "school_code": "30073",
    "udise_code": "6204100371",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 22,
    "school_name": "Government Girls Middle School Jhirka",
    "school_code": "6555",
    "udise_code": "6200203217",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 23,
    "school_name": "Government Middle School Hassanpur Bilora",
    "school_code": "6086",
    "udise_code": "6200202002",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 24,
    "school_name": "Government Middle School Reegarh Nuh Mewat",
    "school_code": "30083",
    "udise_code": "6204100370",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 25,
    "school_name": "Kasturba Gandhi Balika Vidyalaya Firozpur Jhirka",
    "school_code": "6916",
    "udise_code": "6200203215",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 26,
    "school_name": "Government Middle School Sulela",
    "school_code": "6019",
    "udise_code": "6200206902",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 27,
    "school_name": "Government Girl Middle School Patakpur Nuh Mewat",
    "school_code": "30059",
    "udise_code": "6204100330",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 28,
    "school_name": "Government Senior Secondary School Bhakdoli",
    "school_code": "6087",
    "udise_code": "6200201002",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 29,
    "school_name": "Government Senior Secondary School Baded",
    "school_code": "881",
    "udise_code": "6200207301",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 30,
    "school_name": "Government Middle School Malhaka",
    "school_code": "6090",
    "udise_code": "6200204102",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 31,
    "school_name": "Government Middle School Gujar Nangla",
    "school_code": "30077",
    "udise_code": "6204100365",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 32,
    "school_name": "PM Shri Government Senior Secondary School Path Khori",
    "school_code": "920",
    "udise_code": "6200203501",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 33,
    "school_name": "Government Middle School Jetlaka",
    "school_code": "6099",
    "udise_code": "6200204402",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 34,
    "school_name": "Government Middle School Rangla Rajpur",
    "school_code": "6095",
    "udise_code": "6200208602",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 35,
    "school_name": "Government Middle School Luhinga Khurd",
    "school_code": "7164",
    "udise_code": "6200204002",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 36,
    "school_name": "Government Senior Secondary School Rawali",
    "school_code": "890",
    "udise_code": "6200202103",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 37,
    "school_name": "Government Middle School MB Buchaka",
    "school_code": "30081",
    "udise_code": "6204100367",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 38,
    "school_name": "Government Middle School Jharpuri",
    "school_code": "931",
    "udise_code": "6200204201",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 39,
    "school_name": "Government Middle School Falendi Nuh mewat",
    "school_code": "30089",
    "udise_code": "6204100360",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 40,
    "school_name": "Government Middle School Nangli Nuh Mewat",
    "school_code": "30082",
    "udise_code": "6204100376",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 41,
    "school_name": "Government Middle School Naharika",
    "school_code": "6017",
    "udise_code": "6200207102",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 42,
    "school_name": "Government Middle School Rawa",
    "school_code": "6021",
    "udise_code": "6200207202",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 43,
    "school_name": "Government Middle School Padla Shahpuri",
    "school_code": "6016",
    "udise_code": "6200200202",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 44,
    "school_name": "Government Middle School Manota",
    "school_code": "6098",
    "udise_code": "6200207902",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 45,
    "school_name": "Government Middle School Bai Khera",
    "school_code": "6100",
    "udise_code": "6200208502",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 46,
    "school_name": "Government Girl Middle School Badopur Nuh Mewat",
    "school_code": "30009",
    "udise_code": "6204100378",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 47,
    "school_name": "Government Middle School Shekhpur",
    "school_code": "6091",
    "udise_code": "6200206302",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 48,
    "school_name": "Government Middle School Basai Meo",
    "school_code": "829",
    "udise_code": "6200205503",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 49,
    "school_name": "Government Girls Senior Secondary School Ahmadbass",
    "school_code": "6554",
    "udise_code": "6200205004",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 50,
    "school_name": "Government Senior Secondary School Neem Khera",
    "school_code": "938",
    "udise_code": "6200208003",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 51,
    "school_name": "Government Senior Secondary School Mahun",
    "school_code": "825",
    "udise_code": "6200206504",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 52,
    "school_name": "Government Girls Middle School Biwan II",
    "school_code": "6558",
    "udise_code": "6200203105",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 53,
    "school_name": "Aarohi Model Senior Seconadry School Hassanpur Bilonda",
    "school_code": "6631",
    "udise_code": "6200202003",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 54,
    "school_name": "Government Girls Middle School Kameda",
    "school_code": "6013",
    "udise_code": "6200205203",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 55,
    "school_name": "Government Girls Middle School Dhana",
    "school_code": "6559",
    "udise_code": "6200201603",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 56,
    "school_name": "Government Middle School Dondal Nuh",
    "school_code": "30076",
    "udise_code": "6204100375",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 57,
    "school_name": "Government Middle School Madapur Nuh",
    "school_code": "30079",
    "udise_code": "6204100369",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 58,
    "school_name": "Government Middle School Patan Udepuri",
    "school_code": "6015",
    "udise_code": "6200202202",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 59,
    "school_name": "Government Senior Secondary School Ferozpur Jhirka",
    "school_code": "884",
    "udise_code": "6200203202",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 60,
    "school_name": "Government Middle School Ahmadbas",
    "school_code": "6094",
    "udise_code": "6200205003",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 61,
    "school_name": "PM Shri Government Senior Secondary School Sakras",
    "school_code": "871",
    "udise_code": "6200204801",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 62,
    "school_name": "Government Senior Secondary School Bubalheri",
    "school_code": "728",
    "udise_code": "6200201402",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 63,
    "school_name": "CM EEE Government Senior Secondary School Agon",
    "school_code": "818",
    "udise_code": "6200200702",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 64,
    "school_name": "Government Middle School Akhanaka",
    "school_code": "6093",
    "udise_code": "6200202502",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 65,
    "school_name": "Government Girl Middle School Patti Sakras Nuh Mewat",
    "school_code": "30048",
    "udise_code": "6204100368",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 66,
    "school_name": "Government Senior Secondary School Navali",
    "school_code": "6097",
    "udise_code": "6200205702",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 67,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Ferozpur Jhirka",
    "school_code": "28735",
    "udise_code": "6200203216",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 68,
    "school_name": "Government Middle School Ainchwari Nuh Mewat",
    "school_code": "30071",
    "udise_code": "6204100373",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 69,
    "school_name": "Government Middle School Hirwari",
    "school_code": "6018",
    "udise_code": "6200203702",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 70,
    "school_name": "Government Middle School Baghola",
    "school_code": "926",
    "udise_code": "6200203901",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 71,
    "school_name": "Government Middle School Bhond",
    "school_code": "6085",
    "udise_code": "6200201902",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 72,
    "school_name": "Government Model Sanskriti Senior Secondary School Raniyala",
    "school_code": "6088",
    "udise_code": "6200208402",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 73,
    "school_name": "Government Model Sanskriti Senior Secondary School Doha",
    "school_code": "892",
    "udise_code": "6200202802",
    "block": "Ferozepur Jhirka",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 74,
    "school_name": "Government Middle School Chandraka Nuh Mewat",
    "school_code": "30074",
    "udise_code": "6204100372",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 75,
    "school_name": "Government Middle School Chittora Nuh Mewat",
    "school_code": "30075",
    "udise_code": "6204100366",
    "block": "Ferozepur Jhirka",
    "school_type": "Middle School"
  },
  {
    "id": 76,
    "school_name": "Government Middle School Ganduri",
    "school_code": "929",
    "udise_code": "6200401001",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 77,
    "school_name": "Government Middle School Karhera",
    "school_code": "6078",
    "udise_code": "6200405302",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 78,
    "school_name": "Government Girl Middle School Shahpur Nuh Mewat",
    "school_code": "30061",
    "udise_code": "6204100332",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 79,
    "school_name": "Government Middle School Shakawari",
    "school_code": "6064",
    "udise_code": "6200406502",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 80,
    "school_name": "Government Girls Middle School Umra",
    "school_code": "6542",
    "udise_code": "6200403904",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 81,
    "school_name": "Government Middle School Banarsi",
    "school_code": "6083",
    "udise_code": "6200407102",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 82,
    "school_name": "Government Middle School Ranika",
    "school_code": "6075",
    "udise_code": "6200406302",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 83,
    "school_name": "Government Senior Secondary School Umra",
    "school_code": "828",
    "udise_code": "6200403901",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 84,
    "school_name": "Government Middle School Rithat",
    "school_code": "723",
    "udise_code": "6200400703",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 85,
    "school_name": "Government Middle School Aklimpur F.P.",
    "school_code": "6546",
    "udise_code": "6200401802",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 86,
    "school_name": "Government Middle School Uleta",
    "school_code": "722",
    "udise_code": "6200401501",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 87,
    "school_name": "Government Middle School Nangla Puthli",
    "school_code": "7171",
    "udise_code": "6200405502",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 88,
    "school_name": "Government Middle School Rajaka",
    "school_code": "6084",
    "udise_code": "6200404202",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 89,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Nagina Mewat",
    "school_code": "28386",
    "udise_code": "6200401605",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 90,
    "school_name": "Government Middle School Nangla Shahpur",
    "school_code": "6069",
    "udise_code": "6200401302",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 91,
    "school_name": "Government Middle School Bukhara Ka",
    "school_code": "6081",
    "udise_code": "6200406902",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 92,
    "school_name": "CM EEE Government Senior Secondary School Multhan",
    "school_code": "933",
    "udise_code": "6200403402",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 93,
    "school_name": "Government Middle School A.S.Bad",
    "school_code": "6072",
    "udise_code": "6200404002",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 94,
    "school_name": "Government Middle School Dhadoli Kalan",
    "school_code": "6547",
    "udise_code": "6200407303",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 95,
    "school_name": "Government Girl Middle School Bhoodbas Nuh Mewat",
    "school_code": "30065",
    "udise_code": "6204100335",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 96,
    "school_name": "Government Middle School Saral",
    "school_code": "6038",
    "udise_code": "6200404702",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 97,
    "school_name": "Government Girls Middle School Umri",
    "school_code": "6036",
    "udise_code": "6200400903",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 98,
    "school_name": "Government Middle School Hassanpur",
    "school_code": "6068",
    "udise_code": "6200406102",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 99,
    "school_name": "Government Middle School Kherli Khurd",
    "school_code": "6076",
    "udise_code": "6200402702",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 100,
    "school_name": "Government Middle School Zimrawat",
    "school_code": "6077",
    "udise_code": "6200402002",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 101,
    "school_name": "Government Girl Middle School Shadipur Nuh Mewat",
    "school_code": "30063",
    "udise_code": "6204100331",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 102,
    "school_name": "Government Middle School Mohammad Nagar",
    "school_code": "6035",
    "udise_code": "6200404802",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 103,
    "school_name": "Government Senior Secondary School Raniala Patakpur",
    "school_code": "5871",
    "udise_code": "6200404902",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 104,
    "school_name": "Government Middle School Sukhpuri",
    "school_code": "6070",
    "udise_code": "6200402302",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 105,
    "school_name": "Government Middle School D.S.Pur",
    "school_code": "6080",
    "udise_code": "6200402502",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 106,
    "school_name": "PM Shri Government Senior Secondary School Bajidpur",
    "school_code": "891",
    "udise_code": "6200400502",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 107,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Madhi Nagina Mewat",
    "school_code": "28390",
    "udise_code": "6200404503",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 108,
    "school_name": "Government Senior Secondary School Kherli Nuh",
    "school_code": "6033",
    "udise_code": "6200404403",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 109,
    "school_name": "Government Middle School Akhlim Pur Nuh",
    "school_code": "7170",
    "udise_code": "6200406602",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 110,
    "school_name": "Government Middle School Imam Nagar",
    "school_code": "729",
    "udise_code": "6200404601",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 111,
    "school_name": "Aarohi Model Senior Seconadry School Mohammadpur Nagar",
    "school_code": "6632",
    "udise_code": "6200404803",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 112,
    "school_name": "Government Senior Secondary School Bhadas",
    "school_code": "820",
    "udise_code": "6200405701",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 113,
    "school_name": "Government Middle School Mohalaka",
    "school_code": "6548",
    "udise_code": "6200401402",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 114,
    "school_name": "Government Senior Secondary School Ghagas",
    "school_code": "5864",
    "udise_code": "6200400203",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 115,
    "school_name": "PM Shri Government Senior Secondary School Mandi Khera",
    "school_code": "727",
    "udise_code": "6200402803",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 116,
    "school_name": "Government Model Girl Sanskriti Senior Secondary School Khanpur Ghati Mewat",
    "school_code": "28388",
    "udise_code": "6200403204",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 117,
    "school_name": "Government Middle School Khanpur Ghati",
    "school_code": "731",
    "udise_code": "6200403201",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 118,
    "school_name": "Government Middle School Jaitaka",
    "school_code": "6037",
    "udise_code": "6200406703",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 119,
    "school_name": "Government Middle School Jatka Siswana",
    "school_code": "6545",
    "udise_code": "6200405002",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 120,
    "school_name": "Government Senior Secondary School Marora",
    "school_code": "934",
    "udise_code": "6200403301",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 121,
    "school_name": "Government Girl Middle School Karheri Nuh Mewat",
    "school_code": "30064",
    "udise_code": "6204100333",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 122,
    "school_name": "Government Girls Middle School Sultanpur Nuh",
    "school_code": "6541",
    "udise_code": "6200407003",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 123,
    "school_name": "Kasturba Gandhi Balika Vidyalaya Nagina",
    "school_code": "6917",
    "udise_code": "6200401604",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 124,
    "school_name": "Government Senior Secondary School Kansali",
    "school_code": "6079",
    "udise_code": "6200406802",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 125,
    "school_name": "Government Model Sanskriti Senior Secondary School Nagina",
    "school_code": "873",
    "udise_code": "6200401601",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 126,
    "school_name": "Government Girl Middle School Haibitka Nuh Mewat",
    "school_code": "30058",
    "udise_code": "6204100334",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 127,
    "school_name": "Government Middle School Jalal Pur Nuh",
    "school_code": "6929",
    "udise_code": "6200407602",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 128,
    "school_name": "Government Middle School Llibas",
    "school_code": "6549",
    "udise_code": "6200402102",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 129,
    "school_name": "Government Senior Secondary School Basaikhanzada",
    "school_code": "925",
    "udise_code": "6200403102",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 130,
    "school_name": "PM Shri Government Girls Senior Secondary School Nagina",
    "school_code": "826",
    "udise_code": "6200401602",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 131,
    "school_name": "Government Middle School Notki",
    "school_code": "937",
    "udise_code": "6200401101",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 132,
    "school_name": "Government Middle School Balai",
    "school_code": "6073",
    "udise_code": "6200407502",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 133,
    "school_name": "Government Middle School Gumat Bihari",
    "school_code": "6065",
    "udise_code": "6200400102",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 134,
    "school_name": "Government Middle School Gohana",
    "school_code": "5884",
    "udise_code": "6200406002",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 135,
    "school_name": "Government Senior Secondary School Badarpur",
    "school_code": "821",
    "udise_code": "6200402401",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 136,
    "school_name": "Government Middle School Madhi",
    "school_code": "6066",
    "udise_code": "6200404502",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 137,
    "school_name": "Government Senior Secondary School Nangal Mubarikpur",
    "school_code": "936",
    "udise_code": "6200400602",
    "block": "Nagina",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 138,
    "school_name": "Government Middle School Fakarpur Khori",
    "school_code": "7167",
    "udise_code": "6204100508",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 139,
    "school_name": "Government Middle School K.M.Pur",
    "school_code": "6071",
    "udise_code": "6200403602",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 140,
    "school_name": "Government Middle School Jargali",
    "school_code": "6928",
    "udise_code": "6200403002",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 141,
    "school_name": "Government Girls Middle School Khuspuri",
    "school_code": "6034",
    "udise_code": "6200402204",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 142,
    "school_name": "Government Middle School Kherli Kalan",
    "school_code": "6082",
    "udise_code": "6200407202",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 143,
    "school_name": "Government Girl Middle School Pithorpuri Nuh Mewat",
    "school_code": "30060",
    "udise_code": "6204100329",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 144,
    "school_name": "Government Middle School Khan Pur Nuh",
    "school_code": "7168",
    "udise_code": "6200406202",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 145,
    "school_name": "Government Middle School Nai Nangla",
    "school_code": "6074",
    "udise_code": "6200402903",
    "block": "Nagina",
    "school_type": "Middle School"
  },
  {
    "id": 146,
    "school_name": "Government Middle School Baroji",
    "school_code": "6022",
    "udise_code": "6200508902",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 147,
    "school_name": "Government Middle School Birsika",
    "school_code": "6026",
    "udise_code": "6200506102",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 148,
    "school_name": "Government Girl Middle School Bharangaka Nuh Mewat",
    "school_code": "30005",
    "udise_code": "6204100325",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 149,
    "school_name": "Government Girls Senior Secondary School Akera",
    "school_code": "5870",
    "udise_code": "6200511703",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 150,
    "school_name": "Government Girls Middle School Jaisinghpur",
    "school_code": "6537",
    "udise_code": "6200507404",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 151,
    "school_name": "Government Middle School Khedli Dosa",
    "school_code": "6028",
    "udise_code": "6200506502",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 152,
    "school_name": "Government Senior Secondary School Ghasera",
    "school_code": "868",
    "udise_code": "6200501603",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 153,
    "school_name": "Government Senior Secondary School Khor Basai",
    "school_code": "814",
    "udise_code": "6200502802",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 154,
    "school_name": "Government Senior Secondary School Dihana",
    "school_code": "809",
    "udise_code": "6200511602",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 155,
    "school_name": "Government Girl Middle School Atta Nuh Mewat",
    "school_code": "30069",
    "udise_code": "6204100328",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 156,
    "school_name": "Government Girls Middle School Nijampur",
    "school_code": "6025",
    "udise_code": "6200503303",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 157,
    "school_name": "Government Senior Secondary School Khera Khalilpur",
    "school_code": "916",
    "udise_code": "6200501103",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 158,
    "school_name": "Government Senior Secondary School Udaka",
    "school_code": "807",
    "udise_code": "6200500202",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 159,
    "school_name": "Government Girls Middle School Uleta",
    "school_code": "6529",
    "udise_code": "6200504904",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 160,
    "school_name": "Government Middle School Paldi",
    "school_code": "6062",
    "udise_code": "6200504402",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 161,
    "school_name": "Government Middle School Ranika",
    "school_code": "913",
    "udise_code": "6200505901",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 162,
    "school_name": "Government Girl Middle School Raishika",
    "school_code": "30070",
    "udise_code": "6204100327",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 163,
    "school_name": "Government Senior Secondary School Adbar",
    "school_code": "706",
    "udise_code": "6200504702",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 164,
    "school_name": "Government Middle School Terakpur",
    "school_code": "6533",
    "udise_code": "6200510102",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 165,
    "school_name": "Government Senior Secondary School Atta Barota",
    "school_code": "808",
    "udise_code": "6200500302",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 166,
    "school_name": "Government Middle School Sudaka",
    "school_code": "5867",
    "udise_code": "6200509503",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 167,
    "school_name": "Government Model Sanskriti Senior Secondary School Nuh",
    "school_code": "6625",
    "udise_code": "6200508418",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 168,
    "school_name": "Government Girl Middle School Buraka Nuh Mewat",
    "school_code": "30066",
    "udise_code": "6204100324",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 169,
    "school_name": "Government Middle School Golpuri",
    "school_code": "6050",
    "udise_code": "6200509802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 170,
    "school_name": "Government Middle School Hirmathla",
    "school_code": "6030",
    "udise_code": "6200512802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 171,
    "school_name": "PM Shri Government Senior Secondary School Feroz Pur Namak",
    "school_code": "796",
    "udise_code": "6200501503",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 172,
    "school_name": "Government Middle School Sadai",
    "school_code": "7172",
    "udise_code": "6200501802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 173,
    "school_name": "Government Senior Secondary School Chhapera",
    "school_code": "869",
    "udise_code": "6200502701",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 174,
    "school_name": "Government Middle School Kiranj",
    "school_code": "4340",
    "udise_code": "6200504803",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 175,
    "school_name": "Government Girls Senior Secondary School Khor Basai District Nuh",
    "school_code": "29947",
    "udise_code": "6204100236",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 176,
    "school_name": "Government Middle School Raipuri",
    "school_code": "6051",
    "udise_code": "6200504502",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 177,
    "school_name": "Government Middle School Dhanduka",
    "school_code": "6518",
    "udise_code": "6200510302",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 178,
    "school_name": "Government Senior Secondary School Akera",
    "school_code": "802",
    "udise_code": "6200511704",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 179,
    "school_name": "Government Middle School Bajerka",
    "school_code": "6524",
    "udise_code": "6200506702",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 180,
    "school_name": "Government Middle School Untka",
    "school_code": "6023",
    "udise_code": "6200509402",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 181,
    "school_name": "Government Senior Secondary School Rewasan",
    "school_code": "815",
    "udise_code": "6200502202",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 182,
    "school_name": "Government Middle School Noushera",
    "school_code": "5868",
    "udise_code": "6200509902",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 183,
    "school_name": "Government Senior Secondary School Meoli",
    "school_code": "801",
    "udise_code": "6200509002",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 184,
    "school_name": "Government Middle School Nawabgarh",
    "school_code": "6528",
    "udise_code": "6200506802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 185,
    "school_name": "Government Girls Senior Secondary School Ghasera",
    "school_code": "6523",
    "udise_code": "6200501605",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 186,
    "school_name": "Government Middle School Shahpur Nangly",
    "school_code": "5866",
    "udise_code": "6200503702",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 187,
    "school_name": "Government Girls Middle School Chandeni",
    "school_code": "6522",
    "udise_code": "6200501706",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 188,
    "school_name": "Government Middle School Satputiyaka",
    "school_code": "6058",
    "udise_code": "6200510402",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 189,
    "school_name": "Government Senior Secondary School Kurthala",
    "school_code": "803",
    "udise_code": "6200510503",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 190,
    "school_name": "Kasturba Gandhi Balika Vidyalaya Nuh",
    "school_code": "6914",
    "udise_code": "6200508406",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 191,
    "school_name": "Government Girls Senior Secondary School Ujina",
    "school_code": "798",
    "udise_code": "6200505604",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 192,
    "school_name": "Government Middle School Muradabas",
    "school_code": "6049",
    "udise_code": "6200508602",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 193,
    "school_name": "Government High School Alawalpur",
    "school_code": "5869",
    "udise_code": "6200507203",
    "block": "Nuh",
    "school_type": "High School"
  },
  {
    "id": 194,
    "school_name": "Government Senior Secondary School Bibipur",
    "school_code": "6060",
    "udise_code": "6200508202",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 195,
    "school_name": "Government Senior Secondary. School Gangoli",
    "school_code": "915",
    "udise_code": "6200501302",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 196,
    "school_name": "Government Senior Secondary School Salaheri",
    "school_code": "5885",
    "udise_code": "6200504303",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 197,
    "school_name": "Government Middle School Mehrola",
    "school_code": "6056",
    "udise_code": "6200512102",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 198,
    "school_name": "Aarohi Model Senior Seconadry School Rewason",
    "school_code": "6633",
    "udise_code": "6200502205",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 199,
    "school_name": "Government Girls Middle School Salamba",
    "school_code": "810",
    "udise_code": "6200511106",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 200,
    "school_name": "Government Middle School Kontalka",
    "school_code": "6532",
    "udise_code": "6200507502",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 201,
    "school_name": "Government High School Bhiravati",
    "school_code": "918",
    "udise_code": "6200505202",
    "block": "Nuh",
    "school_type": "High School"
  },
  {
    "id": 202,
    "school_name": "Government Senior Secondary School Dewla Nangli",
    "school_code": "6061",
    "udise_code": "6200507103",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 203,
    "school_name": "Government Senior Secondary School Tain",
    "school_code": "714",
    "udise_code": "6200504002",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 204,
    "school_name": "Government Middle School Thekra",
    "school_code": "6535",
    "udise_code": "6200507702",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 205,
    "school_name": "PM Shri Government Senior Secondary School Malab",
    "school_code": "804",
    "udise_code": "6200503401",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 206,
    "school_name": "Government Girl Middle School Meoli Khurd Nuh Mewat",
    "school_code": "30067",
    "udise_code": "6204100326",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 207,
    "school_name": "Government Middle School Dhenkli",
    "school_code": "6534",
    "udise_code": "6200507602",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 208,
    "school_name": "Government Middle School Barelaki",
    "school_code": "6527",
    "udise_code": "6200502902",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 209,
    "school_name": "Government Girls Middle School Devla Nangli",
    "school_code": "6538",
    "udise_code": "6200507104",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 210,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Nuh",
    "school_code": "28736",
    "udise_code": "6200508405",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 211,
    "school_name": "Government Middle School Sonkh",
    "school_code": "6024",
    "udise_code": "6200503902",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 212,
    "school_name": "CM EEE Government Senior Secondary School Tapkan",
    "school_code": "6031",
    "udise_code": "6200504602",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 213,
    "school_name": "Government Middle School Gund Bas",
    "school_code": "6059",
    "udise_code": "6200505702",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 214,
    "school_name": "Government Middle School Bhopawli",
    "school_code": "6531",
    "udise_code": "6200507802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 215,
    "school_name": "Government Middle School Nuh (Co-Edu)",
    "school_code": "6063",
    "udise_code": "6200508404",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 216,
    "school_name": "Government Senior Secondary School Ujina",
    "school_code": "797",
    "udise_code": "6200505602",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 217,
    "school_name": "Government Middle School Bajhera",
    "school_code": "715",
    "udise_code": "6200507902",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 218,
    "school_name": "Government Girl Middle School Dhirdhoka",
    "school_code": "30068",
    "udise_code": "6204100323",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 219,
    "school_name": "Government Middle School Kherli Kankar, Nuh",
    "school_code": "30675",
    "udise_code": "6204100848",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 220,
    "school_name": "Government Middle School Biwan",
    "school_code": "29028",
    "udise_code": "6200510702",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 221,
    "school_name": "Government Middle School Rehna",
    "school_code": "816",
    "udise_code": "6200504102",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 222,
    "school_name": "Government Senior Secondary School Kherla (Nuh)",
    "school_code": "948",
    "udise_code": "6200508702",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 223,
    "school_name": "Government Senior Secondary School Alduka",
    "school_code": "795",
    "udise_code": "6200506903",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 224,
    "school_name": "Government Middle School Babupur - Hathin",
    "school_code": "6118",
    "udise_code": "6200510202",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 225,
    "school_name": "PM Shri Government Senior Secondary School Kamar Sika",
    "school_code": "6055",
    "udise_code": "6200512302",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 226,
    "school_name": "Government High School Manuwas",
    "school_code": "713",
    "udise_code": "6200505303",
    "block": "Nuh",
    "school_type": "High School"
  },
  {
    "id": 227,
    "school_name": "Government Middle School Rithoda",
    "school_code": "912",
    "udise_code": "6200503001",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 228,
    "school_name": "PM Shri Government Senior Secondary School Indri",
    "school_code": "882",
    "udise_code": "6200500502",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 229,
    "school_name": "Government Middle School B.A. Pur",
    "school_code": "5874",
    "udise_code": "6200502402",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 230,
    "school_name": "Government Middle School Kourali",
    "school_code": "6052",
    "udise_code": "6200510802",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 231,
    "school_name": "CM EEE Government Senior Secondary School Kairaka",
    "school_code": "705",
    "udise_code": "6200510001",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 232,
    "school_name": "Government Girls Senior Secondary School Nuh",
    "school_code": "800",
    "udise_code": "6200508403",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 233,
    "school_name": "Government Middle School Gajarpur",
    "school_code": "6027",
    "udise_code": "6200502002",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 234,
    "school_name": "Government Girls Middle School Bai",
    "school_code": "6029",
    "udise_code": "6200509203",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 235,
    "school_name": "Government High School Kotla",
    "school_code": "6048",
    "udise_code": "6200508802",
    "block": "Nuh",
    "school_type": "High School"
  },
  {
    "id": 236,
    "school_name": "Government Middle School Bainsi(Nuh)",
    "school_code": "4337",
    "udise_code": "6200509603",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 237,
    "school_name": "Government Senior Secondary School Sangail",
    "school_code": "707",
    "udise_code": "6200506003",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 238,
    "school_name": "Government Senior Secondary School Chandeni",
    "school_code": "812",
    "udise_code": "6200501703",
    "block": "Nuh",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 239,
    "school_name": "Government Middle School Rojka Meo",
    "school_code": "6054",
    "udise_code": "6200512002",
    "block": "Nuh",
    "school_type": "Middle School"
  },
  {
    "id": 240,
    "school_name": "Government High School Singalheri",
    "school_code": "893",
    "udise_code": "6200107803",
    "block": "Punhana",
    "school_type": "High School"
  },
  {
    "id": 241,
    "school_name": "Government Middle School Thek",
    "school_code": "6121",
    "udise_code": "6200100702",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 242,
    "school_name": "Government Middle School Gubrari Nuh Mewat",
    "school_code": "30094",
    "udise_code": "6204100351",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 243,
    "school_name": "Government Middle School Jalika",
    "school_code": "30104",
    "udise_code": "6204100363",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 244,
    "school_name": "Government Girls Senior Secondary School Singar",
    "school_code": "6566",
    "udise_code": "6200108405",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 245,
    "school_name": "Government Middle School Chandanki",
    "school_code": "6576",
    "udise_code": "6200103502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 246,
    "school_name": "Government Middle School Badka Nuh Mewat",
    "school_code": "30092",
    "udise_code": "6204100354",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 247,
    "school_name": "Government Senior Secondary School Tusaini",
    "school_code": "6130",
    "udise_code": "6200103102",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 248,
    "school_name": "Government Middle School Nakanpur",
    "school_code": "6573",
    "udise_code": "6200102802",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 249,
    "school_name": "Government Middle School Nawalgarh Nuh Mewat",
    "school_code": "30091",
    "udise_code": "6204100350",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 250,
    "school_name": "Government Middle School Piproli Nuh Mewat",
    "school_code": "30095",
    "udise_code": "6204100362",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 251,
    "school_name": "Government Girl Middle School Jakh Nuh Mewat",
    "school_code": "30054",
    "udise_code": "6204100357",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 252,
    "school_name": "Government Girl Middle School Govinspur Nangla",
    "school_code": "30055",
    "udise_code": "6204100352",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 253,
    "school_name": "Government Middle School Khonta",
    "school_code": "30101",
    "udise_code": "6204100355",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 254,
    "school_name": "Government Middle School Bhola Ka Bass",
    "school_code": "7185",
    "udise_code": "6200104102",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 255,
    "school_name": "Government Senior Secondary School Dudoli",
    "school_code": "822",
    "udise_code": "6200100603",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 256,
    "school_name": "CM EEE Government Senior Secondary School Singar",
    "school_code": "870",
    "udise_code": "6200108403",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 257,
    "school_name": "Government Girls Middle School Mohammad Pur",
    "school_code": "6571",
    "udise_code": "6200103903",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 258,
    "school_name": "Government Girl Middle School Papri Nuh Mewat",
    "school_code": "30053",
    "udise_code": "6204100359",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 259,
    "school_name": "Government Middle School Sunheda",
    "school_code": "6128",
    "udise_code": "6200104602",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 260,
    "school_name": "Government Girls Senior Secondary School Shahchokha",
    "school_code": "6569",
    "udise_code": "6200105907",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 261,
    "school_name": "Government Senior Secondary School Jaiwant",
    "school_code": "730",
    "udise_code": "6200105002",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 262,
    "school_name": "Government Middle School Mamlika Nuh Mewat",
    "school_code": "30087",
    "udise_code": "6204100358",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 263,
    "school_name": "Government Middle School Patpadbas",
    "school_code": "6580",
    "udise_code": "6200105702",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 264,
    "school_name": "Government Girls Senior Secondary School Luhinga Kalan",
    "school_code": "6134",
    "udise_code": "6200102204",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 265,
    "school_name": "Government Middle School Ferozepur Meo",
    "school_code": "6044",
    "udise_code": "6200103602",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 266,
    "school_name": "Government Middle School Tundlaka",
    "school_code": "940",
    "udise_code": "6200102002",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 267,
    "school_name": "Government Middle School Fardari",
    "school_code": "6126",
    "udise_code": "6200107102",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 268,
    "school_name": "Government Middle School Badha",
    "school_code": "7184",
    "udise_code": "6200105302",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 269,
    "school_name": "Government Girls Senior Secondary School Jadaoli",
    "school_code": "6129",
    "udise_code": "6200103004",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 270,
    "school_name": "Government Middle School Hazipur",
    "school_code": "6127",
    "udise_code": "6200102602",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 271,
    "school_name": "Government Girls Senior Secondary School Indana",
    "school_code": "6133",
    "udise_code": "6200108204",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 272,
    "school_name": "Government Model Sanskriti Senior Secondary School Saroli",
    "school_code": "872",
    "udise_code": "6200106703",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 273,
    "school_name": "Government Girl Middle School Godholi Nuh Mewat",
    "school_code": "30050",
    "udise_code": "6204100361",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 274,
    "school_name": "Government Senior Secondary School Niwana",
    "school_code": "721",
    "udise_code": "6200101602",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 275,
    "school_name": "Government Middle School Nai Branch Nuh Mewat",
    "school_code": "30103",
    "udise_code": "6204100344",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 276,
    "school_name": "Government Middle School Naheda",
    "school_code": "6131",
    "udise_code": "6200104703",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 277,
    "school_name": "Government Senior Secondary School Bichhor",
    "school_code": "880",
    "udise_code": "6200107904",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 278,
    "school_name": "Government Girl Middle School Khera Jhera Nuh Mewat",
    "school_code": "30049",
    "udise_code": "6204100345",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 279,
    "school_name": "Government Senior Secondary School Outha",
    "school_code": "4653",
    "udise_code": "6200104402",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 280,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Punhana Mewat",
    "school_code": "28715",
    "udise_code": "6200100110",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 281,
    "school_name": "Government Middle School Mundheta",
    "school_code": "6041",
    "udise_code": "6200106502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 282,
    "school_name": "Government Middle School Bhuriyaki Nuh Mewat",
    "school_code": "30099",
    "udise_code": "6204100337",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 283,
    "school_name": "Government Middle School Sultanpupr",
    "school_code": "6578",
    "udise_code": "6200104003",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 284,
    "school_name": "Government Senior Secondary School Hathangaon",
    "school_code": "823",
    "udise_code": "6200105602",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 285,
    "school_name": "Government Middle School Madyaki",
    "school_code": "7173",
    "udise_code": "6200102502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 286,
    "school_name": "Government Senior Secondary School Rajpur",
    "school_code": "6122",
    "udise_code": "6200101202",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 287,
    "school_name": "CM EEE Government Senior Secondary School Jamalgarh",
    "school_code": "726",
    "udise_code": "6200107403",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 288,
    "school_name": "Government Girls Senior Secondary School Nai",
    "school_code": "6568",
    "udise_code": "6200100305",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 289,
    "school_name": "Government Senior Secondary School Jehtana",
    "school_code": "725",
    "udise_code": "6200104503",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 290,
    "school_name": "Government Middle School Bandholi Nuh Mewat",
    "school_code": "30097",
    "udise_code": "6204100341",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 291,
    "school_name": "Government Middle School Jahrokari",
    "school_code": "6125",
    "udise_code": "6200108002",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 292,
    "school_name": "Government Senior Secondary School Shikrawa",
    "school_code": "894",
    "udise_code": "6200100403",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 293,
    "school_name": "CM EEE Government Girls Senior Secondary School Pinangwan",
    "school_code": "874",
    "udise_code": "6200106103",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 294,
    "school_name": "Government Middle School Aminabad",
    "school_code": "6043",
    "udise_code": "6200105502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 295,
    "school_name": "Government Senior Secondary School Lohinga Kalan",
    "school_code": "824",
    "udise_code": "6200102202",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 296,
    "school_name": "Government Middle School Allahbas",
    "school_code": "6132",
    "udise_code": "6200109102",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 297,
    "school_name": "Kasturba Gandhi Balika Vidyalaya Punhana",
    "school_code": "6918",
    "udise_code": "6200100109",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 298,
    "school_name": "Government Middle School Teekri Nuh Mewat",
    "school_code": "30102",
    "udise_code": "6204100342",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 299,
    "school_name": "Government Middle School Satakpuri",
    "school_code": "7186",
    "udise_code": "6200109402",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 300,
    "school_name": "Government Middle School Papra",
    "school_code": "6120",
    "udise_code": "6200105802",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 301,
    "school_name": "Government Girl Middle School Inder ka Bass Nuh Mewat",
    "school_code": "30051",
    "udise_code": "6204100348",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 302,
    "school_name": "Government Middle School Pema Khera",
    "school_code": "732",
    "udise_code": "6200106902",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 303,
    "school_name": "PM Shri Government Girls Senior Secondary School Bisru",
    "school_code": "927",
    "udise_code": "6200100205",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 304,
    "school_name": "Government Middle School Rehapuwa",
    "school_code": "6039",
    "udise_code": "6200104202",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 305,
    "school_name": "Government Middle School Akbarpur",
    "school_code": "5879",
    "udise_code": "6200106202",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 306,
    "school_name": "Government Girls Middle School Hinganpur",
    "school_code": "6579",
    "udise_code": "6200103803",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 307,
    "school_name": "Government Middle School Lafuri",
    "school_code": "6124",
    "udise_code": "6200102402",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 308,
    "school_name": "PM Shri Government Senior Secondary School Punhana",
    "school_code": "885",
    "udise_code": "6200100101",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 309,
    "school_name": "Government Middle School Patakpur",
    "school_code": "6045",
    "udise_code": "6200103402",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 310,
    "school_name": "Government Middle School Tirwara",
    "school_code": "733",
    "udise_code": "6200101502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 311,
    "school_name": "Government Senior Secondary School Ter",
    "school_code": "889",
    "udise_code": "6200104302",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 312,
    "school_name": "Government Senior Secondary School Nai",
    "school_code": "719",
    "udise_code": "6200100303",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 313,
    "school_name": "Government Middle School Gagarbass Nuh Mewat",
    "school_code": "30100",
    "udise_code": "6204100338",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 314,
    "school_name": "Government Girls Senior Secondary School Punhana",
    "school_code": "887",
    "udise_code": "6200100105",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 315,
    "school_name": "Government Senior Secondary School Neemka",
    "school_code": "5880",
    "udise_code": "6200108302",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 316,
    "school_name": "Government Middle School Badli",
    "school_code": "6040",
    "udise_code": "6200101402",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 317,
    "school_name": "Government Girl Middle School Bikti Nuh",
    "school_code": "29992",
    "udise_code": "6204100347",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 318,
    "school_name": "Government Middle School Khawajli Kalan",
    "school_code": "7174",
    "udise_code": "6200100502",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 319,
    "school_name": "Government Middle School Jakhokar Nuh Mewat",
    "school_code": "30093",
    "udise_code": "6204100346",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 320,
    "school_name": "Government Middle School Mubarakpur",
    "school_code": "5881",
    "udise_code": "6200107302",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 321,
    "school_name": "PM Shri Government Senior Secondary School Pinangwan",
    "school_code": "886",
    "udise_code": "6200106102",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 322,
    "school_name": "Government Middle School Kherla Punhana",
    "school_code": "6575",
    "udise_code": "6200104802",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 323,
    "school_name": "Government Middle School Rupaheri Nuh Mewat",
    "school_code": "30090",
    "udise_code": "6204100340",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 324,
    "school_name": "Government Girl Middle School Andhaki",
    "school_code": "29991",
    "udise_code": "6204100343",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 325,
    "school_name": "Government Girls Senior Secondary School Shikrawa",
    "school_code": "6567",
    "udise_code": "6200100409",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 326,
    "school_name": "Government Senior Secondary School Raipur",
    "school_code": "6574",
    "udise_code": "6200103202",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 327,
    "school_name": "Government Senior Secondary School Shahchokha",
    "school_code": "939",
    "udise_code": "6200105903",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 328,
    "school_name": "Government Middle School Godhola",
    "school_code": "6119",
    "udise_code": "6200101902",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 329,
    "school_name": "Government Middle School Gheera",
    "school_code": "6577",
    "udise_code": "6200108703",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 330,
    "school_name": "Government Senior Secondary School Bisru",
    "school_code": "734",
    "udise_code": "6200100201",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 331,
    "school_name": "Government Senior Secondary School Gulalta",
    "school_code": "720",
    "udise_code": "6200103702",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 332,
    "school_name": "Government Middle School Rasoolpur",
    "school_code": "6042",
    "udise_code": "6200101102",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 333,
    "school_name": "Government Middle School Naseerpuri Nuh Mewat",
    "school_code": "30088",
    "udise_code": "6204100356",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 334,
    "school_name": "Government Middle School Rahira Nuh Mewat",
    "school_code": "30096",
    "udise_code": "6204100353",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 335,
    "school_name": "Government Senior Secondary School Laharwari",
    "school_code": "5877",
    "udise_code": "6200107602",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 336,
    "school_name": "Aarohi Model Senior Seconadry School Mundhete",
    "school_code": "6634",
    "udise_code": "6200106503",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 337,
    "school_name": "Government Middle School Indana",
    "school_code": "5878",
    "udise_code": "6200108203",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 338,
    "school_name": "Government Girls Senior Secondary School Jamalgarh",
    "school_code": "6570",
    "udise_code": "6200107406",
    "block": "Punhana",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 339,
    "school_name": "Government High School Gangwani",
    "school_code": "724",
    "udise_code": "6200102302",
    "block": "Punhana",
    "school_type": "High School"
  },
  {
    "id": 340,
    "school_name": "Government Middle School Naharpur Nuh Mewat",
    "school_code": "30098",
    "udise_code": "6204100339",
    "block": "Punhana",
    "school_type": "Middle School"
  },
  {
    "id": 341,
    "school_name": "Government Middle School Kharkhari",
    "school_code": "6146",
    "udise_code": "6200603403",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 342,
    "school_name": "Government Model Sanskriti Senior Secondary School Taoru",
    "school_code": "866",
    "udise_code": "6200600102",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 343,
    "school_name": "Government Model Sanskriti Senior Secondary Schools Tauru",
    "school_code": "28734",
    "udise_code": "6200600112",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 344,
    "school_name": "Government Senior Secondary School Raheri",
    "school_code": "6591",
    "udise_code": "6200603004",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 345,
    "school_name": "Government Middle School Saray",
    "school_code": "6136",
    "udise_code": "6200607102",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 346,
    "school_name": "Government Middle School Dudhera",
    "school_code": "6135",
    "udise_code": "6200602503",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 347,
    "school_name": "Government Girl Middle School Ghusbethi Nuh Mewat",
    "school_code": "30056",
    "udise_code": "6204100381",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 348,
    "school_name": "Government Middle School Utton",
    "school_code": "6142",
    "udise_code": "6200604003",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 349,
    "school_name": "Government Middle School Kalarpuri",
    "school_code": "5882",
    "udise_code": "6200601902",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 350,
    "school_name": "Kasturba Gandhi Balika Vidyalaya Tauru",
    "school_code": "6915",
    "udise_code": "6200600113",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 351,
    "school_name": "Government Girls Senior Secondary School Taoru",
    "school_code": "794",
    "udise_code": "6200600101",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 352,
    "school_name": "Government Middle School Sahlaka Nuh mewat",
    "school_code": "30086",
    "udise_code": "6204100387",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 353,
    "school_name": "Government Girl Middle School Khori Khurd Nuh Mewat",
    "school_code": "30002",
    "udise_code": "6204100379",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 354,
    "school_name": "Government Middle School Bhogipur",
    "school_code": "6585",
    "udise_code": "6200605602",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 355,
    "school_name": "Government Middle School Jafrabad",
    "school_code": "6138",
    "udise_code": "6200606902",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 356,
    "school_name": "Government Middle School Madarka",
    "school_code": "5872",
    "udise_code": "6200605702",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 357,
    "school_name": "Government Middle School Nihalgarh",
    "school_code": "6137",
    "udise_code": "6200604402",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 358,
    "school_name": "Government Middle School Silkho",
    "school_code": "6587",
    "udise_code": "6200605402",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 359,
    "school_name": "Government Senior Secondary School Hasan Pur Taoru",
    "school_code": "867",
    "udise_code": "6200600301",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 360,
    "school_name": "Government Middle School Saini Pura Tauru",
    "school_code": "806",
    "udise_code": "6200601501",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 361,
    "school_name": "Government Middle School Kota Khandewla",
    "school_code": "712",
    "udise_code": "6200601401",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 362,
    "school_name": "Government Middle School Goyla",
    "school_code": "4338",
    "udise_code": "6200601601",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 363,
    "school_name": "Government Middle School Burak",
    "school_code": "6140",
    "udise_code": "6200603202",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 364,
    "school_name": "Government Senior Secondary School Dalawas",
    "school_code": "6141",
    "udise_code": "6200605903",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 365,
    "school_name": "PM Shri Government Senior Secondary School Pachgaon",
    "school_code": "5873",
    "udise_code": "6200603102",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 366,
    "school_name": "Government Senior Secondary School Jaurasi",
    "school_code": "805",
    "udise_code": "6200600201",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 367,
    "school_name": "Government Middle School Sabras",
    "school_code": "6586",
    "udise_code": "6200604502",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 368,
    "school_name": "Government Senior Secondary School Subaseri",
    "school_code": "914",
    "udise_code": "6200601801",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 369,
    "school_name": "Government Girl Middle School Kangarka Nuh",
    "school_code": "29993",
    "udise_code": "6204100383",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 370,
    "school_name": "PM Shri Government Senior Secondary School Mohd.Pur Ahir",
    "school_code": "919",
    "udise_code": "6200600401",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 371,
    "school_name": "Government Senior Secondary School Guranwat",
    "school_code": "6144",
    "udise_code": "6200602702",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 372,
    "school_name": "Government Middle School Beri",
    "school_code": "6592",
    "udise_code": "6200606302",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 373,
    "school_name": "Government Senior Secondary School Chahalka",
    "school_code": "6139",
    "udise_code": "6200602003",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 374,
    "school_name": "CM EEE Government Senior Secondary School Dhulawat",
    "school_code": "716",
    "udise_code": "6200600901",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 375,
    "school_name": "Government Middle School Sikarpur",
    "school_code": "5886",
    "udise_code": "6200603302",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 376,
    "school_name": "Government Girls High School Hassanpur Taoru",
    "school_code": "711",
    "udise_code": "6200600302",
    "block": "Taoru",
    "school_type": "High School"
  },
  {
    "id": 377,
    "school_name": "CM EEE Government Senior Secondary School Bissar Akbarpur",
    "school_code": "6053",
    "udise_code": "6200606403",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 378,
    "school_name": "Shaheed Nk Sis Ram Government Senior Secondary School Sundh",
    "school_code": "708",
    "udise_code": "6200606702",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 379,
    "school_name": "Government Senior Secondary School Padheni",
    "school_code": "917",
    "udise_code": "6200600501",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 380,
    "school_name": "Shaheed Harparsad Government Senior Secondary School Kalwari",
    "school_code": "799",
    "udise_code": "6200600601",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 381,
    "school_name": "Government Senior Secondary School Nijampur",
    "school_code": "5875",
    "udise_code": "6200602902",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 382,
    "school_name": "Government Senior Secondary School Chharora",
    "school_code": "811",
    "udise_code": "6200601701",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 383,
    "school_name": "Government Senior Secondary School Chilla",
    "school_code": "5876",
    "udise_code": "6200605002",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 384,
    "school_name": "Government Middle School Dingarheri",
    "school_code": "6588",
    "udise_code": "6200606102",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 385,
    "school_name": "Aarohi Model Senior Seconadry School Bawala",
    "school_code": "6635",
    "udise_code": "6200605303",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 386,
    "school_name": "Government Girl Middle School Para Nuh Mewat",
    "school_code": "30004",
    "udise_code": "6204100385",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 387,
    "school_name": "Government Middle School Sewka",
    "school_code": "6590",
    "udise_code": "6200603804",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 388,
    "school_name": "Government Senior Secondary School Patuka",
    "school_code": "717",
    "udise_code": "6200601001",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 389,
    "school_name": "Government Middle School Chilawli",
    "school_code": "6047",
    "udise_code": "6200604902",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 390,
    "school_name": "Government Senior Secondary School Rathiwas",
    "school_code": "710",
    "udise_code": "6200600701",
    "block": "Taoru",
    "school_type": "Senior Secondary School"
  },
  {
    "id": 391,
    "school_name": "Government Girl Middle School Kaliyaki Nuh Mewat",
    "school_code": "30001",
    "udise_code": "6204100380",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 392,
    "school_name": "Government Middle School Gwarka Nuh Mewat",
    "school_code": "30006",
    "udise_code": "6204100382",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 393,
    "school_name": "Government Girl Middle School Kiruri Nuh Mewat",
    "school_code": "30057",
    "udise_code": "6204100388",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 394,
    "school_name": "Government Middle School Pipaka",
    "school_code": "6147",
    "udise_code": "6200602202",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 395,
    "school_name": "Government Middle School Chundhika",
    "school_code": "7175",
    "udise_code": "6200607603",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 396,
    "school_name": "Government Middle School Malhaka Nuh Mewat",
    "school_code": "30085",
    "udise_code": "6204100386",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 397,
    "school_name": "Government Girl Middle School Nanuka Nuh Mewat",
    "school_code": "30003",
    "udise_code": "6204100384",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 398,
    "school_name": "Government Middle School Bhango Tauru Nuh Mewat",
    "school_code": "30464",
    "udise_code": "6204100594",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 399,
    "school_name": "Government Middle School Bawla",
    "school_code": "6145",
    "udise_code": "6200605302",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 400,
    "school_name": "Government Middle School Raniyaki",
    "school_code": "6589",
    "udise_code": "6200604303",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 401,
    "school_name": "Government Middle School Sunari",
    "school_code": "817",
    "udise_code": "6200601101",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 402,
    "school_name": "Government Middle School Jhammuwas",
    "school_code": "718",
    "udise_code": "6200601304",
    "block": "Taoru",
    "school_type": "Middle School"
  },
  {
    "id": 403,
    "school_name": "Government Girls Middle School Khori Kalan",
    "school_code": "6143",
    "udise_code": "6200601204",
    "block": "Taoru",
    "school_type": "Middle School"
  }
];
